<template>
  <van-collapse v-model="activeNames">
    <van-collapse-item class="r-1" title="处罚详情" name="1">
      <van-cell-group><van-field label="决定书文号" :value="data.caseNo" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="违法类型" :value="data.illegalType" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="处罚事由" :value="data.punishReason" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="处罚依据" :value="data.punishBasis" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="处罚结果" :value="data.punishmentResult" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="处罚日期" :value="data.punishDate" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="处罚单位" :value="data.punishGov" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="执行情况" :value="data.implementation" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
    <van-collapse-item title="行政相对人信息" name="2">
      <div
        class="item coll2 comWrapper card mt-2 mb-2 p-3"
        v-for="(item, index) in data.companyInfoList"
        :key="index"
      >
        <div class="comWrapper-wrapper van-hairline--bottom">
          <span></span>
          {{ item[companyInfoListCol[0].field] }}
        </div>
        <van-cell-group>
          <template v-for="(col, idx) in companyInfoListCol">
            <van-cell
              v-if="idx > 0"
              :key="'col_' + idx"
              :title="col.title"
              :value="item[col.field]"
            />
          </template>
        </van-cell-group>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>

<script>
import detailMixin from "../mixins/detail-mixin"
export default {
  name: "envPunishmentCheckDetail",
  mixins: [detailMixin],
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
      companyInfoListCol: [
        {title: "序号", field: "sort" },
        // {title: "KeyNo", field: "keyNo"},
        {title: "名称", field: "name"}
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "../style.scss";
.r-1 /deep/ .van-collapse-item__content {
  padding: 0px 16px;
}
.coll2 .van-cell__value {
  flex: 1;
  margin-left: 8px;
}
.coll2 .van-cell {
  padding: 10px 0;

  &::after{
    left: 0;
  }
}

.coll3 /deep/ .van-field__label {
  flex: 1;
}
</style>